import {
  Box,
  Button,
  CircularProgress,
  CssBaseline,
  Typography,
} from "@mui/material";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import React, { useEffect } from "react";
import { useSnackbar } from "notistack";
import MainHeader from "../../components/MainHeader";
import About from "../../components/SignupAluno/About";
import Address from "../../components/SignupAluno/Address";
import PersonalData from "../../components/SignupAluno/PersonalData";
import HeaderSecti from "../../components/HeaderSecti";

import ReviewConfirm from "../../components/SignupAluno/ReviewConfirm";
import api from "../../services/api";
import history from "../../services/history";
import Rodape from "../../components/Rodape";
import { Link } from "react-router-dom";

// Tokens IGUAIS aos do SignIn (artboard "Login Oxetech", opcao 1b "Cartao
// central"): o cadastro passou a usar a mesma casca do login, entao os valores
// tem de ser os mesmos arquivo a arquivo -- fundo creme, circulos decorativos e
// um unico cartao branco centralizado. O painel de marca laranja do artboard
// "Cadastro Oxetech" saiu junto com o layout em duas colunas.
const CAD = {
  fundo: "#FFF9EF",
  circuloA: "#FCEFD6",
  circuloB: "#FBE7D3",
  cartaoBorda: "#F0E6D6",
  laranja: "#D2551D",
  laranjaHover: "#B8460F",
  azul: "#2C5FA8",
  titulo: "#1F1E1C",
  textoSuave: "#6B655D",
  rotulo: "#3B3833",
  campoBorda: "#E2DACD",
  trilho: "#EDE4D6",
};

const FONTE_CAD = "'Poppins', system-ui, sans-serif";

const DESTAQUES_CADASTRO = [
  "18 trilhas em 8 áreas de tecnologia",
  "Turmas presenciais em 11 cidades",
  "Certificados e currículo para as vagas",
];

// Subtítulo de cada etapa REAL do cadastro (o protótipo tinha 3; aqui são 4).
const TEXTO_ETAPA = [
  "Usamos o CPF para identificar seu cadastro na plataforma.",
  "Onde você mora — isso ajuda a indicar turmas e laboratórios perto de você.",
  "Conte um pouco sobre seu momento e seus interesses.",
  "Revise o que preencheu e escolha uma senha de acesso.",
];

const steps = ["Dados Pessoais", "Residência", "Info", "Confirmação"];
// const steps = ["Sobre mim" ];

var personalData = {},
  addressData = {},
  infoData = {},
  passDet = {};
function getStepContent(step) {
  switch (step) {
    case 0:
      return <PersonalData />;
    case 1:
      return <Address />;
    case 2:
      return <About />;
    case 3:
      return <ReviewConfirm />;
    default:
      throw new Error("Etapa desconhecida");
  }
}

function SignUpAluno() {
  const [activeStep, setActiveStep] = React.useState(0);
  const [alunoParams, setAlunoParams] = React.useState({});
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (activeStep === 4) {
      api
        .post(
          "aluno/create",
          {
            params: {
              ...alunoParams.addressData,
              ...alunoParams.personalData,
              ...alunoParams.infoData,
              ...alunoParams.passDet,
              // comprovante_id: sessionStorage.getItem("comprovante_id"),
              accept_privacy_policies: true,
            },
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then(function (success) {
          sessionStorage.clear();
          history.push("/sucess");
        })
        .catch(function (error) {
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            enqueueSnackbar("Erro no cadastro: " + error.response.data.error, { variant: "error" });
          } else {
            enqueueSnackbar("Ocorreu um erro no cadastro!", { variant: "error" });
          }
          window.location.reload();
        });
    }
  }, [activeStep, alunoParams]);

  function saveData() { }

  const handleNext = () => {
    personalData = {
      name: sessionStorage.getItem("fullName"),
      email: sessionStorage.getItem("email"),
      telefone: sessionStorage.getItem("phoneNumber"),
      cpf: sessionStorage.getItem("cpf"),
      data_nascimento: sessionStorage.getItem("birthDate"),
      genero: sessionStorage.getItem("gender")
    };
    addressData = {
      rua: sessionStorage.getItem("rua"),
      bairro: sessionStorage.getItem("bairro"),
      municipio: sessionStorage.getItem("municipio"),
      cep: sessionStorage.getItem("cep"),
      estado: sessionStorage.getItem("estado"),
      numero: sessionStorage.getItem("numero"),
      // comprovante_id: sessionStorage.getItem("comprovante_id"),
    };

    infoData = {
      sobre_mim: sessionStorage.getItem("sobre_mim"),
      foco_carreira: sessionStorage.getItem("foco_carreira"),
      ocupacao: sessionStorage.getItem("ocupacao"),
    };
    passDet = {
      password: sessionStorage.getItem("pass"),
      accept_privacy_policies: sessionStorage.getItem("privacy_policies"),
    };
    if (sessionStorage.getItem("emailValido") === "incorreto") {
      enqueueSnackbar("Não foi possível validar o email.", { variant: "warning" });
    } else if (sessionStorage.getItem("cpfValido") === "incorreto") {
      enqueueSnackbar("Não foi possível validar o CPF.", { variant: "warning" });
    } else if (sessionStorage.getItem("birthDate") === null) {
      enqueueSnackbar("Verifique sua data de nascimento.", { variant: "warning" });
    } else if (Object.values(personalData).some((v) => v === null)) {
      enqueueSnackbar("Preencha todos os campos obrigatórios para avançar.", { variant: "warning" });
    } else if (
      activeStep === 1 &&
      Object.values(addressData).some((v) => v === null)
    ) {
      enqueueSnackbar("Preencha todos os campos para avançar.", { variant: "warning" });
    } else if (
      activeStep === 2 &&
      Object.values(infoData).some((v) => v === "")
    ) {
      enqueueSnackbar("Preencha todos os campos para avançar.", { variant: "warning" });
    } else if (
      activeStep === 3 &&
      Object.values(passDet).some((v) => v === null)
    ) {
      enqueueSnackbar("Preencha todos os campos para avançar.", { variant: "warning" });
    } else if (
      activeStep === 4 &&
      passDet.accept_privacy_policies === "false"
    ) {
      enqueueSnackbar("Precisa aceitar as políticas de privacidade para avançar.", { variant: "warning" });
    } else {
      personalData.nome_social = sessionStorage.getItem("socialName") || "";
      setActiveStep(activeStep + 1);
      setAlunoParams({ personalData, addressData, infoData, passDet });
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  // Casca IGUAL a da tela de login (SignIn): fundo creme, dois circulos
  // decorativos e um unico cartao branco centralizado. Antes esta tela usava o
  // layout em duas colunas do artboard "Cadastro Oxetech" (painel de marca
  // laranja a esquerda) -- pedido do Marcelo em 04/09/2026 para as duas telas de
  // entrada terem a mesma pegada. O cartao aqui e mais largo que o do login (760
  // contra 520) porque as etapas tem linhas de dois campos (e-mail/telefone).
  //
  // ATENCAO: o design propoe um fluxo de 3 etapas com campos (perfil,
  // escolaridade, curso, cidade) que NAO existem no cadastro real. O contrato de
  // `POST aluno/create` exige nome, e-mail, telefone, CPF, data de nascimento,
  // genero, endereco completo, sobre_mim/foco_carreira/ocupacao e senha -- por
  // isso as 4 etapas reais e seus componentes seguem intactos; so a casca visual
  // mudou. Trocar as etapas pelas do design quebraria a criacao de conta.
  const passoAtual = Math.min(activeStep, steps.length - 1);

  return (
    <>
      <HeaderSecti />
      <CssBaseline />
      <MainHeader />

      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          background: CAD.fundo,
          color: CAD.titulo,
          minHeight: { xs: "auto", md: "78vh" },
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: { xs: 5, md: 8 },
          px: 2,
        }}
      >
        {/* Circulos decorativos do design, nas mesmas posicoes do login.
            aria-hidden e pointerEvents none para nao entrarem na navegacao por
            leitor de tela nem capturarem clique. */}
        <Box
          aria-hidden
          sx={{
            position: "absolute",
            left: -120,
            top: 60,
            width: 300,
            height: 300,
            borderRadius: "50%",
            background: CAD.circuloA,
            pointerEvents: "none",
            display: { xs: "none", md: "block" },
          }}
        />
        <Box
          aria-hidden
          sx={{
            position: "absolute",
            right: -90,
            bottom: -90,
            width: 340,
            height: 340,
            borderRadius: "50%",
            background: CAD.circuloB,
            pointerEvents: "none",
            display: { xs: "none", md: "block" },
          }}
        />

        <Box
          sx={{
            position: "relative",
            width: "100%",
            maxWidth: 760,
            background: "#fff",
            borderRadius: "20px",
            border: `1px solid ${CAD.cartaoBorda}`,
            boxShadow: "0 22px 50px rgba(70, 40, 10, .13)",
            p: { xs: "32px 24px", sm: "44px 48px" },
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            minWidth: 0,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: "18px" }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "20px", flexWrap: "wrap" }}>
              <Typography component="span" sx={{ fontFamily: FONTE_CAD, fontSize: 13, fontWeight: 600, letterSpacing: ".16em", textTransform: "uppercase", color: CAD.laranja }}>
                {`Etapa ${passoAtual + 1} de ${steps.length}`}
              </Typography>
              <Typography component="span" sx={{ fontFamily: FONTE_CAD, fontSize: 13.5, color: CAD.textoSuave }}>
                Já tem conta?{" "}
                <Link to="/login" style={{ color: CAD.laranja, fontWeight: 600, textDecoration: "none" }}>
                  Entrar
                </Link>
              </Typography>
            </Box>

            {/* Uma barra por etapa real (4), não as 3 do protótipo. */}
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {steps.map((rotulo, i) => (
                <Box
                  key={rotulo}
                  sx={{
                    flex: 1,
                    height: "5px",
                    borderRadius: "99px",
                    transition: "background .35s ease",
                    background: i <= passoAtual ? CAD.laranja : CAD.trilho,
                  }}
                />
              ))}
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: "5px", textAlign: "center" }}>
              <Typography component="h1" sx={{ fontFamily: FONTE_CAD, fontSize: { xs: 26, sm: 30 }, fontWeight: 700, letterSpacing: "-.01em", color: CAD.titulo }}>
                {steps[passoAtual]}
              </Typography>
              <Typography sx={{ fontFamily: FONTE_CAD, fontSize: 15, lineHeight: 1.55, color: CAD.textoSuave }}>
                {TEXTO_ETAPA[passoAtual]}
              </Typography>
            </Box>
          </Box>

          {activeStep === steps.length ? (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: 6, gap: 2 }}>
              <CircularProgress sx={{ color: CAD.laranja }} />
              <Typography sx={{ fontFamily: FONTE_CAD, color: CAD.laranja }}>
                Realizando seu cadastro...
              </Typography>
            </Box>
          ) : (
            <React.Fragment>
              <Box sx={{ minWidth: 0 }}>{getStepContent(activeStep)}</Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                {/* Na etapa 1 o Voltar NAO e renderizado. Antes era escondido com
                    `visibility: hidden`, que esconde mas MANTEM a caixa: o
                    Continuar ficava empurrado para a direita e nao centralizava
                    no cartao. Sem o botao, o `flex: 1` do Continuar ocupa a
                    linha inteira e ele centra. */}
                {activeStep > 0 && (
                  <Button
                    onClick={handleBack}
                    sx={{
                      height: 56,
                      px: "24px",
                      borderRadius: "11px",
                      background: "#fff",
                      border: `1.5px solid ${CAD.campoBorda}`,
                      fontFamily: FONTE_CAD,
                      fontSize: 15,
                      fontWeight: 600,
                      textTransform: "none",
                      color: CAD.rotulo,
                      flex: "none",
                      "&:hover": { background: CAD.fundo, border: `1.5px solid ${CAD.campoBorda}` },
                    }}
                  >
                    Voltar
                  </Button>
                )}

                {/* Primario LARANJA, igual ao ENTRAR do login (era azul). Duas
                    telas de entrada com acoes primarias de cores diferentes era
                    justamente o que destoava. */}
                <Button
                  onClick={handleNext}
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    flex: 1,
                    height: 56,
                    borderRadius: "11px",
                    background: CAD.laranja,
                    color: "#fff",
                    fontFamily: FONTE_CAD,
                    fontSize: 16,
                    fontWeight: 600,
                    letterSpacing: ".06em",
                    textTransform: "uppercase",
                    boxShadow: "0 10px 22px rgba(210, 85, 29, .26)",
                    "&:hover": { background: CAD.laranjaHover },
                    "&:active": { transform: "translateY(1px)" },
                  }}
                >
                  {activeStep === steps.length - 1 ? "Criar conta" : "Continuar"}
                </Button>
              </Box>
            </React.Fragment>
          )}

          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "9px", pt: "14px", borderTop: `1px solid ${CAD.trilho}`, fontFamily: FONTE_CAD, fontSize: 13, color: CAD.textoSuave, textAlign: "center" }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><rect x="4.5" y="10.5" width="15" height="9.5" rx="2" /><path d="M8.2 10.5V7.8a3.8 3.8 0 017.6 0v2.7" /></svg>
            Seus dados são usados apenas para fins do programa OxeTech.
          </Box>
        </Box>

        {/* Os tres argumentos que ficavam no painel laranja. Sem o painel eles
            perderiam a tela, entao viraram uma linha discreta sob o cartao --
            mesmo lugar que o login usa para "Precisa de ajuda?". */}
        <Box
          sx={{
            position: "relative",
            mt: "22px",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: "10px", sm: "26px" },
          }}
        >
          {DESTAQUES_CADASTRO.map((texto) => (
            <Box
              key={texto}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontFamily: FONTE_CAD,
                fontSize: 13.5,
                fontWeight: 500,
                color: CAD.textoSuave,
              }}
            >
              <Box component="span" aria-hidden sx={{ display: "inline-flex", color: CAD.laranja }}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12.5l4.5 4.5L19 7" /></svg>
              </Box>
              {texto}
            </Box>
          ))}
        </Box>
      </Box>

      <Rodape />
    </>
  );
}

export default SignUpAluno;
